<template>
    <div class="plan">
        <p class = "planLine"><span class = "planText">Growth</span></p>
        <div class="plan_card_container mb-15 white-box" :class="{active: planName === 'growthAggressive'}" @click="selectPlan('growthAggressive')">
                <div class = "investmentContainer">
                    <span class="earn_text">Earn upto</span>
                    <span class = "investmentValue">Invested: &#x20B9;{{growthAggressive | localeAmount}}</span>
                </div>
                <span class = "planPercentageText">18%
                    <span class="perAnnumnText">per annum</span>
                </span>
                <span class = "planTypeText">Growth Aggressive</span>
                <span class = "tenure_text">Lock-in 12 Months</span>
        </div>
        <div class="plan_card_container mb-25 white-box" :class="{active: planName === 'growthConservative'}" @click="selectPlan('growthConservative')">
                <div class = "investmentContainer">
                    <span class="earn_text">Earn upto</span>
                    <span class = "investmentValue">Invested: &#x20B9;{{growthConservative | localeAmount}}</span>
                </div>
                <span class = "planPercentageText">14%
                    <span class="perAnnumnText">per annum</span>
                </span>
                <span class = "planTypeText">Growth Conservative</span>
                <span class = "tenure_text">Lock-in 12 Months</span>
        </div>
        <p class = "planLine"><span class = "planText">Income</span></p>
        <div class="plan_card_container mb-15 white-box" :class="{active: planName === 'incomeAggressive'}" @click="selectPlan('incomeAggressive')">
                <div class = "investmentContainer">
                    <span class="earn_text">Earn upto</span>
                    <span class = "investmentValue">Invested: &#x20B9;{{incomeAggressive | localeAmount}}</span>
                </div>
                <span class = "planPercentageText">16%
                    <span class="perAnnumnText">per annum</span>
                </span>
                <span class = "planTypeText">Income Aggressive</span>
                <span class = "tenure_text">Lock-in 12 Months</span>
        </div>
        <div class="plan_card_container white-box" :class="{active: planName === 'incomeConservative'}" @click="selectPlan('incomeConservative')">
                <div class = "investmentContainer">
                    <span class="earn_text">Earn upto</span>
                    <span class = "investmentValue">Invested: &#x20B9;{{incomeConservative | localeAmount}}</span>
                </div>
                <span class = "planPercentageText">12%
                    <span class="perAnnumnText">per annum</span>
                </span>
                <span class = "planTypeText">Income Conservative</span>
                <span class = "tenure_text">Lock-in 12 Months</span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PlanSelectionCard',
    data () {
        return {
            planName: null,
            incomeConservative: 0,
            incomeAggressive: 0,
            growthConservative: 0,
            growthAggressive: 0
        }
    },
    mounted () {
        const cart = this.$store.getters['dashboard/getAllPortfolios']
        for (var i = 0; i < cart.length; i++) {
            if (cart[i].planType === 'income' && cart[i].riskProfile === 'conservative') {
                if (cart[i]?.investmentValue) {
                    this.incomeConservative = Math.round(cart[i].investmentValue / 100)
                }

                if (cart[i]?.pendingInvestmentAmount) {
                    this.incomeConservative += Math.round(cart[i].pendingInvestmentAmount / 100)
                }
            } else if (cart[i].planType === 'income' && cart[i].riskProfile === 'aggressive') {
                if (cart[i]?.investmentValue) {
                    this.incomeAggressive = Math.round(cart[i].investmentValue / 100)
                }
                if (cart[i]?.pendingInvestmentAmount) {
                    this.incomeAggressive += Math.round(cart[i].pendingInvestmentAmount / 100)
                }
            } else if (cart[i].planType === 'growth' && cart[i].riskProfile === 'aggressive') {
                if (cart[i]?.investmentValue) {
                    this.growthAggressive = Math.round(cart[i].investmentValue / 100)
                }
                if (cart[i]?.pendingInvestmentAmount) {
                    this.growthAggressive += Math.round(cart[i].pendingInvestmentAmount / 100)
                }
            } else if (cart[i].planType === 'growth' && cart[i].riskProfile === 'conservative') {
                if (cart[i]?.investmentValue) {
                    this.growthConservative = Math.round(cart[i].investmentValue / 100)
                }
                if (cart[i]?.pendingInvestmentAmount) {
                    this.growthConservative += Math.round(cart[i].pendingInvestmentAmount / 100)
                }
            }
        }
    },
    methods: {
        selectPlan (plan) {
            this.planName = plan
            this.$emit('selectPlan', this.planName)
        }
    }
}
</script>
<style lang="scss" scoped>

.active {
    background-color: #0c0c2d !important;
    .earn_text, .investmentValue, .planPercentageText, .perAnnumnText, .planTypeText, .tenure_text{
        color: #ffffff
    }
}
.investmentValue {
    color: #4f4f4f;
    font-size: 13px;
    width: -webkit-fill-available;
    text-align: right;
    padding-right: 15px;
}
.investmentContainer {
    display: flex;
    flex-direction: row;
}
.white-box {
    background-color: #fff8e7;
    border: 0px solid #E5E5E5;
    cursor: default;
    padding-left: 24px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 0px
}
.plan_card_container {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 320px;
}
.tenure_text {
    font-weight: 400;
    font-size: 12px;
    color: #8C8C8C;
}

.earn_text {
    width: 100%;
    font-size: 14px;
    color: #9e9e9e;
    font-weight: 500
}

.planPercentageText {
    font-size: 28px;
    color: #002fa7;
    font-weight: 700
}

.perAnnumnText {
    font-size: 12px;
    color: #232323;
    font-weight: 400;
    padding-left: 1px
}

.planTypeText {
    text-transform: capitalize;
    font-size: 17px;
    color: #232323;
    font-weight: 800
}
.tenureContainer {
    padding-bottom: 0px;
}

.planLine {
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    line-height: 0.1em;
    margin: 10px 0 20px;
}

.planText {
    background: #fff;
    padding: 0 10px;
    font-weight: 500;
    font-size: 18px;
    color: #9e9e9e;
}

@media (max-width: 480px) {
    .plan_card_container {
        width: 300px;
    }
}
</style>
